import React from 'react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap'

import { format, areIntervalsOverlapping, parseISO } from 'date-fns'
import ActionsDropdown from 'src/components/system_wide/actions_dropdown'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import DayPicker from 'src/components/system_wide/day_picker'
import ReactNumericInput from 'src/components/system_wide/numeric_input'
import SelectBrandModal from 'src/components/system_wide/select_brand_modal'
import { Trans } from 'react-i18next'
import { getTargets, saveTarget, deleteTarget, resetTargets } from 'src/store/users'
import { getAllBrands } from 'src/store/brand'

const { t } = i18next

const mstp = state => {
  let { total_targets, targets } = state.users
  let { all_brands: brands } = state.brands
  return { total_targets, targets, brands }
}

class TargetForm extends React.Component {
  static defaultProps = {
    is_management: false,
    user: {},
    closeForm: () => {},
  }

  state = {
    id: null,
    start_date: null,
    end_date: null,
    num_contract: 0,
    num_memberships: 0,
    period_real_contract: null,
    num_real_contract: 0,
    user_data_id: null,
    brand_id: null,

    show_edit_form: false,
    error: false,
    error_msg: '',
    error_period_msg: '',
  }

  tableRef = null

  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
    this.state.user_data_id = props.user.id
  }

  async componentDidMount() {
    await this.props.dispatch(getAllBrands())
  }
  componentWillUnmount() {
    this.props.dispatch(resetTargets())
  }

  actions = [
    {
      icon: 'fa-edit',
      text: t('actions.edit', 'Modifica'),
      onClick: rowData => {
        let {
          id,
          start_date,
          end_date,
          num_contract,
          num_memberships,
          period_real_contract,
          num_real_contract,
          user_data_id,
          brand_id,
        } = rowData
        this.setState({
          show_edit_form: true,
          id,
          start_date,
          end_date,
          num_contract,
          num_memberships,
          period_real_contract,
          num_real_contract,
          user_data_id,
          brand_id,
        })
      },
    },
    {
      icon: 'fa-trash-alt',
      text: t('actions.delete', 'Elimina'),
      onClick: async rowData => {
        let { id } = rowData
        await this.props.dispatch(deleteTarget({ id }))
        this.tableRef.current?.refreshData()
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  columns = [
    {
      title: '',
      className: 'd-lg-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.target_form.start_date', 'Data inizio'),
      className: 'd-none d-lg-block',
      style: { width: '18%' },
      sortable: true,
      data: 'start_date',
    },
    {
      title: t('components.target_form.fine_date', 'Data fine'),
      className: 'd-none d-lg-block',
      style: { width: '18%' },
      sortable: true,
      data: 'end_date',
    },
    {
      title: t('components.target_form.num_contract', 'Contratti'),
      className: 'd-none d-lg-block text-center',
      style: { width: '18%' },
      sortable: true,
      data: 'num_contract',
    },
    {
      title: t('components.target_form.num_memberships', 'Affiliazioni'),
      className: 'd-none d-lg-block text-center',
      style: { width: '18%' },
      sortable: true,
      data: 'num_memberships',
    },
    {
      title: t('components.target_form.brand', 'Brand'),
      className: 'd-none d-lg-block text-center',
      style: { width: '19%' },
      sortable: false,
      data: ({ rowData }) => {
        return this.props?.brands?.find(b => b.id === rowData.brand_id)?.name ?? ''
      },
    },
  ]

  getData = async (index = 0, chunkSize, sortData, filter) => {
    await this.props.dispatch(
      getTargets({ offset: index, limit: chunkSize, sortData, filter, user_id: this.state.user_data_id })
    )
  }

  handleChangeDate = name => target => {
    this.setState({ [name]: target.value, error: false, error_msg: '' }, () => this.validateForm())
  }

  onChangeNumericInput = (value, rawValue, { name }) => {
    this.setState({ [name]: value, error: false, error_msg: '' }, () => this.validateForm())
  }

  handleChangeBrands = brands => {
    this.setState({ brand_id: parseInt(brands[0]), error: false, error_msg: '' }, () => this.validateForm())
  }

  onToggleForm = () => {
    this.setState({
      show_edit_form: !this.state.show_edit_form,
      id: null,
      num_contract: 0,
      num_memberships: 0,
      start_date: null,
      end_date: null,
      period_real_contract: null,
      num_real_contract: 0,
      brand_id: null,
      error: false,
      error_msg: '',
      error_period_msg: '',
    })
    this.tableRef.current?.refreshData()
  }

  handleSaveTargets = async () => {
    let { show_edit_form, error_msg, error, ...target } = this.state
    target.start_date = target.start_date ? format(target.start_date, 'yyyy-MM-dd') : ''
    target.end_date = target.end_date ? format(target.end_date, 'yyyy-MM-dd') : ''
    target.period_real_contract = target.period_real_contract ? format(target.period_real_contract, 'yyyy-MM-dd') : ''
    await this.props.dispatch(saveTarget({ target }))
    this.tableRef.current?.refreshData()
    this.onToggleForm()
  }

  validateForm = () => {
    let { id, start_date, end_date, period_real_contract } = this.state
    let { targets } = this.props
    if (start_date && end_date && start_date > end_date) {
      this.setState({
        error: true,
        error_msg: t(
          'components.users.edit_target_form.error_end_date_before_start',
          'La data di fine deve essere maggiore della data di inizio'
        ),
      })
    }
    if (start_date && end_date) {
      let overlaps = targets
        .filter(t => t.id !== id)
        .some(t => {
          let interval = { start: parseISO(t.start_date), end: parseISO(t.end_date) }
          let newInterval = { start: start_date, end: end_date }
          return areIntervalsOverlapping(interval, newInterval) && t.brand_id === this.state.brand_id
        })
      if (overlaps) {
        this.setState({
          error: true,
          error_msg: t(
            'components.users.edit_target_form.error_period_overlap',
            'Esiste già un obiettivo con periodo in sovrapposizione'
          ),
        })
      }
    }
    if (start_date && end_date && period_real_contract) {
      let s_date = typeof start_date === 'string' ? parseISO(start_date) : start_date
      let e_date = typeof end_date === 'string' ? parseISO(end_date) : end_date
      let p_date = typeof period_real_contract === 'string' ? parseISO(period_real_contract) : period_real_contract
      if (p_date < s_date || p_date > e_date) {
        this.setState({
          error: true,
          error_period_msg: t(
            'components.users.edit_target_form.error_period_real_contract',
            "La data di rilevazione deve essere compresa tra la data di inizio e quella di fine dell'obiettivo"
          ),
        })
      }
    }
  }

  render() {
    let {
      show_edit_form,
      error,
      error_msg,
      error_period_msg,
      id,
      start_date,
      end_date,
      num_contract,
      num_memberships,
      period_real_contract,
      num_real_contract,
      brand_id,
    } = this.state

    return (
      <>
        <div className="flex-row position-relative overflow-auto mb-2">
          <div className="">
            <div className="flex-fill flex-sm-grow-0 flex-sm-shrink-0">
              <Button size="sm" onClick={this.onToggleForm} disabled={this.props.show_form}>
                <i className="fas fa-plus fa-fw text-start me-0" />
                <Trans i18nKey="buttons.add_target">Aggiungi obiettivo</Trans>
              </Button>
            </div>
          </div>
        </div>
        <div className="flex-fill position-relative overflow-auto mb-2">
          <div className=" w-100">
            <div className="d-flex flex-row" style={{ height: '60vh' }}>
              <ResponsiveTable
                ref={this.tableRef}
                className="flex-fill"
                data={this.props?.targets ?? []}
                getData={this.getData}
                totalRecords={this.props.total_targets}
                columns={this.columns}
                showMenu={false}
                menuContent={() => null}
                rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
                filter={this.state.filter}
              />
            </div>
          </div>
        </div>
        <div className="border-top pt-2">
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.close">Chiudi</Trans>
          </Button>
        </div>

        <Modal backdrop="static" centered show={show_edit_form} onHide={this.onToggleForm}>
          <Modal.Header>
            <Modal.Title>
              {!id && <Trans i18nKey="components.users.edit_target_form.create_modal.title">Crea obiettivo</Trans>}
              {id && <Trans i18nKey="components.users.edit_target_form.edit_modal.title">Modifica obiettivo</Trans>}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <SelectBrandModal
                user_id={this.props.user.id}
                multiSelection={false}
                required={true}
                selected={brand_id !== null ? [brand_id] : []}
                onChange={this.handleChangeBrands}
              />
            </Form.Group>
            <Form.Group as={Row} className="mb-0 mb-sm-3">
              <Col md="6" className="mb-sm-0 mb-3">
                <Form.Label className=" py-0">
                  <Trans i18nKey="components.users.edit_target_form.edit_modal.start_date">Data inizio</Trans>
                  <span> *</span>
                </Form.Label>
                <div style={{ width: '15rem' }}>
                  <DayPicker value={start_date} onChange={this.handleChangeDate('start_date')} />
                </div>
              </Col>
              <Col md="6" className="mb-sm-0 mb-3">
                <Form.Label className=" py-0">
                  <Trans i18nKey="components.users.edit_target_form.edit_modal.end_date">Data fine</Trans>
                  <span> *</span>
                </Form.Label>
                <div style={{ width: '15rem' }}>
                  <DayPicker
                    value={end_date}
                    onChange={this.handleChangeDate('end_date')}
                    disabled={start_date === null}
                  />
                </div>
              </Col>
              {error === true && (
                <Col md="12" className="mt-3 mb-sm-0 mb-3 text-danger">
                  <em>{error_msg}</em>
                </Col>
              )}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col md="6" className="mb-sm-0 mb-3">
                <Form.Group>
                  <Form.Label className=" py-0">
                    <Trans i18nKey="components.users.edit_target_form.edit_modal.num_contract">Num. contratti</Trans>
                    <span> *</span>
                  </Form.Label>
                  <div style={{ width: '8rem' }}>
                    <ReactNumericInput
                      className="form-control form-control-md"
                      precision={0}
                      min="0"
                      step="1"
                      snap
                      inputMode="decimal"
                      strict
                      name="num_contract"
                      value={num_contract}
                      onChange={this.onChangeNumericInput}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col className="col-6 mb-sm-0 mb-3">
                <Form.Group>
                  <Form.Label className="py-0">
                    <Trans i18nKey="components.users.edit_target_form.edit_modal.num_membership">Num. affiliati</Trans>
                    <span> *</span>
                  </Form.Label>
                  <div style={{ width: '8rem' }}>
                    <ReactNumericInput
                      className="form-control form-control-md"
                      precision={0}
                      min="0"
                      step="1"
                      snap
                      inputMode="decimal"
                      strict
                      name="num_memberships"
                      value={num_memberships}
                      onChange={this.onChangeNumericInput}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Form.Group>
            <Row className="mt-5">
              <h5>
                <Trans i18nKey="components.users.edit_target_form.edit_modal.real_data">Rilevazioni</Trans>
              </h5>
              <Form.Group as={Col} md="6" sm="12" className="mb-2 mb-3">
                <Form.Label className=" py-0">
                  <Trans i18nKey="components.users.edit_target_form.edit_modal.period_real_contract">
                    Data rilevazione
                  </Trans>
                </Form.Label>
                <div style={{ width: '15rem' }}>
                  <DayPicker value={period_real_contract} onChange={this.handleChangeDate('period_real_contract')} />
                </div>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-2 mb-3">
                <Form.Label className="py-0">
                  <Trans i18nKey="components.users.edit_target_form.edit_modal.num_real_contract">
                    Num. contratti effettivi
                  </Trans>
                </Form.Label>
                <div style={{ width: '8rem' }}>
                  <ReactNumericInput
                    className="form-control form-control-md"
                    precision={0}
                    min="0"
                    step="1"
                    snap
                    inputMode="decimal"
                    strict
                    name="num_real_contract"
                    value={num_real_contract}
                    onChange={this.onChangeNumericInput}
                  />
                </div>
              </Form.Group>
              {error === true && (
                <Col md="12" className="mb-3 text-danger">
                  <em>{error_period_msg}</em>
                </Col>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onToggleForm} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button
              onClick={this.handleSaveTargets}
              variant="primary"
              disabled={
                error === true ||
                num_contract === 0 ||
                num_memberships === 0 ||
                start_date === null ||
                end_date === null ||
                brand_id === null
              }>
              <Trans i18nKey="buttons.save">Salva</Trans>
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}
export default connect(mstp, null, null, { forwardRef: true })(TargetForm)
